<div class="cm-placeholder" [class.cm-placeholder--loading]="$loading()" [class.cm-placeholder--dark]="$dark()">
    <div class="cm-placeholder-spacer"></div>
    <i class="cm-placeholder-image far fa-image"></i>
</div>
